import _ from "lodash"; 
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";

export default () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();

  return (path, options) => {
    const searchParamsString = searchParams.toString();
    const pathWithSearch = (_.isEmpty(searchParamsString) || _.isNumber(path)) ? path : `${path}?${searchParamsString}`;

    if (options?.useWindowLocation && location.pathname !== path) {
      if (options?.replace) {
        window.location.replace(pathWithSearch);
      } else {
        window.location.href = pathWithSearch;
      }
      return;
    }

    return navigate(pathWithSearch, options);
  }
};